// these APIs are auto-imported from @vueuse/core
export const isDark = useDark({
  valueDark: 'app-dark',
  valueLight: 'app-light',
})
export const toggleDark = useToggle(isDark)
export const preferredDark = usePreferredDark()
